const getImgSize = (res) => {
  let size;

  if (res === 'low') {
    if (window.innerWidth <= 400) {
      size = 'w200';
    } else if (window.innerWidth > 400) {
      size = 'w300';
    }
  } else if (res === 'med') {
    if (window.innerWidth <= 400) {
      size = 'w200';
    } else if (window.innerWidth > 400 && window.innerWidth < 1000) {
      size = 'w300';
    } else if (window.innerWidth > 1000) {
      size = 'w500';
    }
  }

  return size;
};

const getProfileSize = () => {
  let size;

  if (window.innerWidth <= 400) {
    size = 'w185';
  } else {
    size = 'h632';
  }
  return size;
};

export const base = {
  key: 'd451583a241097fc45eae3dac7f09f98',
  urlPrefix: 'https://api.themoviedb.org/3',
  language: 'language=de',
  region: 'region=DE',
  lowImgPrefix: 'https://image.tmdb.org/t/p/w185',
  imgPrefix: `https://image.tmdb.org/t/p/${getImgSize('low')}`,
  medImgPrefix: `https://image.tmdb.org/t/p/${getImgSize('med')}`,
  // posterPrefix: 'https://image.tmdb.org/t/p/w1280',
  posterPrefix: 'https://image.tmdb.org/t/p/original',
  medProfilePrefix: 'https://image.tmdb.org/t/p/w185',
  profilePrefix: `https://image.tmdb.org/t/p/${getProfileSize()}`,
  profilePlaceholder: 'https://image.tmdb.org/t/p/w45',
};

export const searchBase = {
  movieGenres: [
    { option: 'Action', value: 28 },
    { option: 'Abenteuer', value: 12 },
    { option: 'Animation', value: 16 },
    { option: 'Dokumentarfilm', value: 99 },
    { option: 'Drama', value: 18 },
    { option: 'Familie', value: 10751 },
    { option: 'Fantasy', value: 14 },
    { option: 'Historie', value: 36 },
    { option: 'Horror', value: 27 },
    { option: 'Komödie', value: 35 },
    { option: 'Kriegsfilm', value: 10752 },
    { option: 'Krimi', value: 80 },
    { option: 'Liebesfilm', value: 10749 },
    { option: 'Musik', value: 10402 },
    { option: 'Mystery', value: 9648 },
    { option: 'Science Fiction', value: 878 },
    { option: 'Thriller', value: 53 },
    { option: 'TV-Film', value: 10770 },
    { option: 'Western', value: 37 },
  ],
  tvGenres: [
    { option: 'Action & Adventure', value: 10759 },
    { option: 'Animation', value: 16 },
    { option: 'Dokumentarfilm', value: 99 },
    { option: 'Drama', value: 18 },
    { option: 'Familie', value: 10751 },
    { option: 'Kids', value: 10762 },
    { option: 'Komödie', value: 35 },
    { option: 'Krimi', value: 80 },
    { option: 'Mystery', value: 9648 },
    { option: 'News', value: 10763 },
    { option: 'Reality', value: 10764 },
    { option: 'Sci-Fi & Fantasy', value: 10765 },
    { option: 'Soap', value: 10766 },
    { option: 'Talk', value: 10767 },
    { option: 'War & Politics', value: 10768 },
    { option: 'Western', value: 37 },
  ],

  rate: [
    { option: '8 Punkte und mehr', value: 8 },
    { option: '7 Punkte und mehr', value: 7 },
    { option: '6 Punkte und mehr', value: 6 },
    { option: '5 Punkte und mehr', value: 5 },
    { option: 'ab 3 Punkte', value: 3 },
  ],

  sort: [
    { option: 'Beliebtheit (Absteigend)', value: 'popularity.desc' },
    { option: 'Beliebtheit (Aufsteigend)', value: 'popularity.asc' },
    { option: 'Jahr (Absteigend)', value: 'primary_release_date.desc' },
    { option: 'Jahr (Aufsteigend)', value: 'primary_release_date.asc' },
    { option: 'Bewertungen (Absteigend)', value: 'vote_average.desc' },
    { option: 'Bewertungen (Aufsteigend)', value: 'vote_average.asc' },
    { option: 'Anzahl der Bewertungen', value: 'vote_count.desc' },
  ],

  country: [
    { option: 'USA', value: 'US' },
    { option: 'Deutschland', value: 'DE' },
  ],
};
